import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from './components/error-boundary';
import { LanguageProvider } from './contexts/language-context';
import { ThemeProvider } from './contexts/theme-context';
import { FeatureFlagProvider } from './providers/feature-flag-provider';
import { router } from './router';

export function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <LanguageProvider>
          <FeatureFlagProvider>
            <RouterProvider router={router} />
          </FeatureFlagProvider>
        </LanguageProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
